var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.3408,
    fill: "#F9F9F9",
    stroke: "#DCDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4.9814C9.01916 4.9814 4.9814 9.01916 4.9814 14C4.9814 18.9808 9.01916 23.0186 14 23.0186C18.9808 23.0186 23.0186 18.9808 23.0186 14C23.0186 9.01916 18.9808 4.9814 14 4.9814Z",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5336 17.8106L10.0004 13.0809L14.0102 10.1589L18.0199 13.0809L16.4891 17.8106H11.5336Z",
    fill: "#323232",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4584 5.66838L14.0102 7.14116L10.5635 5.66838",
    fill: "#323232"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4584 5.66838L14.0102 7.14116L10.5635 5.66838",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.189 8.0885L7.52308 11.87L5.01277 14.7591",
    fill: "#323232"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.189 8.0885L7.52308 11.87L5.01277 14.7591",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28714 18.6661L10.0012 19.5217L11.9516 22.7849",
    fill: "#323232"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28714 18.6661L10.0012 19.5217L11.9516 22.7849",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0758 22.7786L18.0199 19.5202L21.7176 18.6685",
    fill: "#323232"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0758 22.7786L18.0199 19.5202L21.7176 18.6685",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9888 14.7364L20.4965 11.8677L20.829 8.10968",
    fill: "#323232"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9888 14.7364L20.4965 11.8677L20.829 8.10968",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0102 7.14116V10.1589",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0199 13.0809L20.4965 11.8677",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4891 17.8106L18.0199 19.5202",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5336 17.8106L10.0012 19.5217",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52308 11.87L10.0004 13.0809",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79733 9.25663C6.67584 9.543 6.58595 9.83722 6.48198 10.1296C6.35533 10.4858 6.14459 10.8164 6.06774 11.1888C5.96476 11.6879 5.70087 12.1309 5.54037 12.6124C5.45423 12.8708 5.44708 13.1402 5.39873 13.4061C5.38071 13.5052 5.32211 13.799 5.32211 13.6983",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2623 19.3962C7.89035 19.6474 8.47382 20.0678 9.03199 20.4459C9.49348 20.7585 9.9902 20.9911 10.3957 21.3879C10.5464 21.5353 10.6056 21.7322 10.7446 21.8794C10.7888 21.9262 10.8302 21.9587 10.8873 21.9873C10.9915 22.0394 10.6545 21.9383 10.5559 21.8763C9.89173 21.4588 9.05786 21.3214 8.4754 20.7821C8.3116 20.6304 8.08686 20.4735 8.03456 20.2382C8.0161 20.1551 7.98563 20.0722 7.94734 19.9956",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3106 5.69529C15.5568 5.69529 14.8051 5.69428 14.0525 5.66833C13.6408 5.65413 13.1912 5.63012 12.7839 5.69529C12.5511 5.73253 12.3078 5.74064 12.0798 5.67308C12.0026 5.65021 11.735 5.72255 11.8293 5.58111",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5331 13.6589C22.5331 12.9694 22.3684 12.2683 22.2825 11.5848C22.2152 11.0488 22.1018 10.5324 21.921 10.0228C21.8265 9.75658 21.7035 9.55402 21.4627 9.42021C21.3373 9.35055 21.4411 9.62588 21.4484 9.67869C21.4958 10.022 21.5686 10.3816 21.6482 10.7189C21.7004 10.9399 21.7338 11.176 21.7338 11.404C21.7338 11.5177 21.7426 11.6213 21.7909 11.718",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0813 21.9651C17.428 21.8448 17.7182 21.6167 17.9693 21.3657C18.3787 20.9562 18.8994 20.6763 19.3505 20.3254C19.5423 20.1762 19.774 20.0379 19.9832 19.9163C20.1959 19.7926 20.3893 19.7446 20.5065 19.5103",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMl);
export default __webpack_public_path__ + "static/media/mål.bb2d952a6f37c8e0d982bdba32fdcf56.svg";
export { ForwardRef as ReactComponent };